import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import * as moment from "moment";
import {LeadEventApiDto, LeadWatcherEventDataApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import {getUser} from "../../../store/view/user";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import _ = require("underscore");

/**
 * Lead watcher changed event.
 */
export default class LeadWatcherEvent extends LeadEvent {
	/**
	 * @param {string} id identifier of event.
	 * @param {string} leadId lead id.
	 * @param {LeadEventTypeEnum} type type of the event.
	 * @param {AuthenticatedEntity} entity entity which creates the event.
	 * @param {moment.Moment} creationDate creation date of event.
	 * @param {string} referenceNumber lead reference number.
	 * @param {LeadWatcherEventData} data lead watcher change event data.
	 */
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadWatcherEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadWatcherEvent {
		const data = LeadWatcherEventData.fromJson(json.data as LeadWatcherEventDataApiDto);
		const entity = AuthenticatedEntity.fromJson(json.entity);
		return new LeadWatcherEvent(json.id, json.leadId, LeadEventTypeEnum.WatchersChanged, entity, moment(json.createdAt),
			json.referenceNumber, data);
	}

	getIcon() {
		return this.isWatcherRemoved() ? Icon.X : Icon.Watch;
	}

	getActivityMessage(): string {
		return this.getWatchersMessage();
	}

	/**
	 * Get changed watchers message.
	 * @return {string}
	 */
	getWatchersMessage() {
		const added = _.difference(this.data.currentWatchers, this.data.previousWatchers);
		const removed = _.difference(this.data.previousWatchers, this.data.currentWatchers);
		let toReturn = "";

		if (added.length) {
			toReturn = (this.getJoinedUserDisplayNames(added) + " added to watchers")
		}
		if (removed.length) {
			if (added.length) {
				toReturn += " / "
			}
			toReturn += (this.getJoinedUserDisplayNames(removed) + " removed from watchers")
		}
		return toReturn;
	}

	getJoinedUserDisplayNames(userIds: string[]): string {
		return userIds.map(id => getUser(id).map(u => u.getDisplayName()).getOrElse("")).join(", ");
	}

	/**
	 * Indicates if watcher has been removed.
	 * @return {boolean}
	 */
	isWatcherRemoved() {
		return (this.data.currentWatchers.length - this.data.previousWatchers.length) < 0;
	}
}


export class LeadWatcherEventData {
	constructor(public readonly previousWatchers: string[],
		public readonly currentWatchers: string[]) {}

	public static fromJson(json: LeadWatcherEventDataApiDto): LeadWatcherEventData {
		return new LeadWatcherEventData(json.previousWatchers, json.currentWatchers);
	}
}
